<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 科研资源 -->
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body" style="min-height: 529px;">
                    <div class="dropdown float-right"></div>
                    <h3 class="header-title froDeskHeader-tit mb-3 mt-1 pb-2">
                      <span class="tit">科研资源</span>
                      <span class="ml-1">Research Resources</span>
                    </h3>
                    <div class="search_box text-right">
                      <span>搜索：</span>
                      <el-input style="width:200px" v-model="query.name" placeholder="关键字搜索" @blur="handleSearch(false)" @keyup.enter.native="handleSearch(false)"></el-input>
                    </div>
                    <ul class="nav nav-pills nav-filter mt-4 mb-3">
                      <li class="nav-item" @click="handleSearch('all')">
                        <a class="nav-link" :class="activeType=='all'?'active':''">全部</a>
                      </li>
                      <li class="nav-item" v-for="item in typeList" :key="item.id" @click="handleSearch(item.id)">
                        <a class="nav-link" :class="activeType==item.id?'active':''">{{item.name}}</a>
                      </li>
                    </ul>
                    <div class="table-responsive">
                      <table id="proApp-datatable" class="table table-hover table-bordered table-centered table-proApp">
                        <thead>
                          <tr>
                            <th class="text-center">资源名称</th>
                            <th class="text-center">上传人</th>
                            <th class="text-center">类别</th>
                            <th class="text-center">资源格式</th>
                            <th class="text-center">上传时间</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-if="list.length>0">
                            <tr v-for="item in list" :key="item.id">
                              <td class="item_name text-left" @click="handleLook(item)">{{item.name}}</td>
                              <td class="text-center">{{item.adminName}}</td>
                              <td class="text-center">{{item.resourcesName}}</td>
                              <td class="text-center">{{item.resourcesFormat}}</td>
                              <td class="text-center">{{item.createTime?item.createTime.substring(0,16):''}}</td>
                            </tr>

                          </template>
                          <tr v-else>
                            <td colspan="5" class="text-center">暂无数据</td>
                          </tr>
                        </tbody>
                      </table>
                      <el-pagination :page-size="query.pageSize" layout="sizes, prev, pager, next" :total="total" :page-sizes="[15, 50, 100]" @current-change="handlePageChange" @size-change="handleSizeChange">
                      </el-pagination>
                    </div>
                  </div> <!-- end card-body-->
                </div> <!-- end card-->
              </div>
              <!-- end 科研资源-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="视频预览" :visible.sync="filePreviewDialogVisible" width="50%" :before-close="closePreviewFileDialog">
      <div class="preview_wrap">
        <video ref="previewVideo" style="width: 80%;height: 400px;" autoplay controls :src="curPreviewFileUrl"></video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewFileDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { getResourcesList } from "@/api/before/home";
import {
  getPlatformInformationData
} from "@/api/after/systemManagement.js";
export default {
  name: "researchResources",
  components: {},
  data() {
    return {
      curPreviewFileUrl: '',//视频附件url
      filePreviewDialogVisible: false,//附件预览弹框
      query: {
        "name": "",
        "pageNumber": 1,
        "pageSize": 15,
        "resourcesId": null
      },
      list: [],
      total: 0,
      typeQuery: {
        dictTypeId: 3,
        pageNumber: 1,
        pageSize: 100,
        pageSorts: [{ asc: true, column: "" }],
      },
      typeList: [],
      activeType: "all",
    };
  },
  mounted() {
    this.getScientificResourceType()
    this.getData();
  },
  methods: {
    getData() {
      getResourcesList(this.query).then((res) => {
        console.log('科研资源数据', res);
        if (res.code == 200) {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关闭文件预览对话框
    closePreviewFileDialog() {
      this.filePreviewDialogVisible = false
      this.$refs.previewVideo.pause();
    },
    handleLook(fileData) {
      if (/\.(png|jpeg|jpg|gif|PNG|JPEG|JPG|GIF)$/.test(fileData.resourcesFormat)) {
        window.open(`${this.uploadUrl}/upload/previewImage/${fileData.annexId}`, '_blank')
      } else if (/\.(doc|docx|DOC|DOCX)$/.test(fileData.resourcesFormat)) {
        window.open(`${this.uploadUrl}/upload/downloadPdf/${fileData.annexId}`, '_blank')
      } else if (/\.(mp4|rm|rmvb|3gp|avi|mpeg|mpg|mkv|dat|asf|wmv|flv|mov|ogg|ogm|RM|RMVB|3GP|AVI|MPEG|MPG|MKV|DAT|ASF|WMV|FLV|MOV|MP4|OGG|OGM)$/.test(fileData.resourcesFormat)) {
        this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${fileData.annexId}`
        this.filePreviewDialogVisible = true
        // window.open(`${this.uploadUrl}/upload/previewVideo/${fileData.annexId}`, '_blank')// 视频
      } else if (/\.(pdf|PDF)$/.test(fileData.resourcesFormat)) {
        window.open(`${this.uploadUrl}/upload/previewPdf/${fileData.annexId}`, '_blank')
      } else if (/\.(pptx|PPTX)$/.test(fileData.resourcesFormat)) {
        window.open(`${this.uploadUrl}/upload/pptConversionPdf/${fileData.annexId}`, '_blank')
      } else {
        window.open(`${this.uploadUrl}/upload/download?id=${fileData.annexId}&openStyle=1`, '_blank')
      }
    },
    // 获取科研资源类别
    async getScientificResourceType() {
      const res = await getPlatformInformationData(3);
      console.log("科研资源类别", res);
      if (res.code == 200) {
        this.typeList = res.data;
      } else {
        this.$message.error(res.data);
      }
    },
    // getResourcesTypeList() {
    //   getResourcesTypeList(this.typeQuery).then((res) => {
    //     if (res.code == 200) {
    //       this.typeList = res.data.records;
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    handleSearch(id) {
      if (id) {
        this.activeType = id;
        if (id == "all") {
          this.query.resourcesId = null;
        } else {
          this.query.resourcesId = id;
        }
      }
      this.query.pageNumber = 1;
      this.getData();
    },
    // 分页器
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.query.pageNumber = 1;
      this.getData();
    },
  },
};
</script>
<style>
.preview_wrap {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item_name{
  color: #66b1ff;
  cursor: pointer;
}
.search_box {
  margin-top: -70px;
}
/* 分页器样式 */
.el-pagination {
  text-align: right;
}
.el-pager li {
  margin: 0 4px;
  padding: 0;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}
.el-pager li.active {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
  border-radius: 50%;
}
.el-pager li.active:hover {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
}
.el-pager li:hover {
  color: #313a46;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
  border-radius: 50%;
}
</style>
<style lang="scss" scoped>
</style>